import { __extends, __awaiter, __makeTemplateObject, __decorate, __metadata, __assign as _assign, __generator } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { PvdAnimation } from '../pvd-utils/scripts/animation.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';

var ExpandCollapseState;
(function (ExpandCollapseState) {
    ExpandCollapseState["collapsed"] = "collapsed";
    ExpandCollapseState["collapsing"] = "collapsing";
    ExpandCollapseState["expanded"] = "expanded";
    ExpandCollapseState["expanding"] = "expanding";
})(ExpandCollapseState || (ExpandCollapseState = {}));
var EXPAND_COLLAPSE_ANIMATION_DURATION = 250;
var DEFAULT_DISABLE_ANIMATION = false;
var DEFAULT_EXPAND = false;
var DEFAULT_EXPAND_ON_PRINT = false;
var DEFAULT_SIZE = StandardSize.medium;
/**
 * Providence Expand-Collapse component.
 * @see {@link https://providence.fmr.com/components/expand-collapse/expand-collapse.html|Expand-Collapse documentation}
 */
var PvdExpandCollapse = /** @class */ (function (_super) {
    __extends(PvdExpandCollapse, _super);
    function PvdExpandCollapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        // #region LitElement properties
        // public event handlers
        _this.animationEndEventHandler = function () {
            _this.pvdExpand ? _this.expanded() : _this.collapsed();
            _this.removeAnimationEndEvent();
        };
        _this.afterPrintEventHandler = function () {
            if (!_this._expandStateBeforePrint) {
                _this.collapsed();
            }
        };
        _this.beforePrintEventHandler = function () {
            _this._expandStateBeforePrint = _this.pvdExpand;
            _this.expanded();
        };
        _this.pvdDisableAnimation = DEFAULT_DISABLE_ANIMATION;
        /**
         * We have to make this a regular getter/setter property instead of a reactive
         * property because a reactive property will cause a re-render on change. If
         * the component is re-rendered, the expand/collapse animation will not work.
         */
        _this._pvdExpand = DEFAULT_EXPAND;
        _this.pvdExpandOnPrint = DEFAULT_EXPAND_ON_PRINT;
        _this.pvdSize = DEFAULT_SIZE;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdExpandCollapse.prototype, "pvdExpand", {
        get: function () {
            return this._pvdExpand;
        },
        set: function (newVal) {
            this._pvdExpand = newVal;
            if (!this.pvdExpand) {
                this.removeAttribute('pvd-expand');
            }
            else {
                this.setAttribute('pvd-expand', '');
            }
            this.expandStateChange();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdExpandCollapse, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region public methods
    PvdExpandCollapse.prototype.toggleExpandState = function () {
        this.pvdExpand = !this.pvdExpand;
        this.expandStateChange();
    };
    PvdExpandCollapse.prototype.addAnimationEndEvent = function () {
        this._contentEl.addEventListener('pvd-animation:end', this.animationEndEventHandler);
    };
    PvdExpandCollapse.prototype.removeAnimationEndEvent = function () {
        this._contentEl.removeEventListener('pvd-animation:end', this.animationEndEventHandler);
    };
    PvdExpandCollapse.prototype.addExpandOnPrintEventListener = function () {
        window.addEventListener('beforeprint', this.beforePrintEventHandler);
        window.addEventListener('afterprint', this.afterPrintEventHandler);
    };
    PvdExpandCollapse.prototype.removeExpandOnPrintEventListener = function () {
        window.removeEventListener('beforeprint', this.beforePrintEventHandler);
        window.removeEventListener('afterprint', this.afterPrintEventHandler);
    };
    Object.defineProperty(PvdExpandCollapse.prototype, "hasSubHeading", {
        // #endregion
        // #region protected methods
        get: function () {
            return this.isSlotUsed('subheading');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdExpandCollapse.prototype, "iconSize", {
        get: function () {
            return this.pvdSize === StandardSize.large ? Size.medium : Size.small;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdExpandCollapse.prototype, "prefersReducedMotionSetting", {
        get: function () {
            var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            return prefersReducedMotion.matches;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // # region private methods
    PvdExpandCollapse.prototype.expandStateChange = function () {
        if (this.pvdExpand && this._state === ExpandCollapseState.collapsed) {
            this.expanding();
        }
        else if (!this.pvdExpand && this._state === ExpandCollapseState.expanded) {
            this.collapsing();
        }
    };
    PvdExpandCollapse.prototype.expanding = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._state = ExpandCollapseState.expanding;
                        // waiting for modifier classes to update
                        return [4 /*yield*/, this.requestUpdate()];
                    case 1:
                        // waiting for modifier classes to update
                        _a.sent();
                        this.triggerChangeEvent();
                        // if `prefers-reduced-motion: reduce` or pvdDisableAnimation are enabled, bypass animation
                        if (this.prefersReducedMotionSetting || this.pvdDisableAnimation) {
                            this.expanded();
                        }
                        else {
                            this.animateContent();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdExpandCollapse.prototype.expanded = function () {
        this._state = ExpandCollapseState.expanded;
        // needing to set height from animation to `auto` for dynamic content
        this._contentEl.style.height = 'auto';
        this.triggerChangeEvent();
        this.triggerExpandedEvent();
    };
    PvdExpandCollapse.prototype.collapsing = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._state = ExpandCollapseState.collapsing;
                        // waiting for modifier classes to update
                        return [4 /*yield*/, this.requestUpdate()];
                    case 1:
                        // waiting for modifier classes to update
                        _a.sent();
                        this.triggerChangeEvent();
                        // if `prefers-reduced-motion: reduce` or pvdDisableAnimation are enabled, bypass animation
                        if (this.prefersReducedMotionSetting || this.pvdDisableAnimation) {
                            this.collapsed();
                        }
                        else {
                            this.animateContent();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdExpandCollapse.prototype.collapsed = function () {
        this._state = ExpandCollapseState.collapsed;
        this.triggerChangeEvent();
        this.triggerCollapsedEvent();
    };
    PvdExpandCollapse.prototype.animateContent = function () {
        var _this = this;
        this._contentHeight = this._contentEl.scrollHeight;
        this._destHeight = this._state === ExpandCollapseState.expanding ? this._contentHeight : 0;
        var animation = new PvdAnimation(this._contentEl, 'height', EXPAND_COLLAPSE_ANIMATION_DURATION);
        setTimeout(function () {
            _this.addAnimationEndEvent();
            animation.start(_this._destHeight);
        }, 0);
    };
    PvdExpandCollapse.prototype.triggerChangeEvent = function () {
        var event = new CustomEvent('pvd-expand-collapse-change', {
            detail: { expand: this.pvdExpand, state: this._state },
        });
        this.dispatchEvent(event);
    };
    PvdExpandCollapse.prototype.triggerExpandedEvent = function () {
        var event = new CustomEvent('pvd-expand-collapse-expanded', {});
        this.dispatchEvent(event);
    };
    PvdExpandCollapse.prototype.triggerCollapsedEvent = function () {
        var event = new CustomEvent('pvd-expand-collapse-collapsed', {});
        this.dispatchEvent(event);
    };
    Object.defineProperty(PvdExpandCollapse.prototype, "generatedInteractionButtonId", {
        /**
         * Creates a generated id for the interaction button
         * @return a generated id to bee used for the interaction button
         */
        get: function () {
            if (!this._generatedInteractionButtonId) {
                this._generatedInteractionButtonId = "pvd-expand-collapse-interaction-button-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedInteractionButtonId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdExpandCollapse.prototype, "generatedContentId", {
        /**
         * Creates a generated id for the content
         * @return a generated id to be used for the content wrapper
         */
        get: function () {
            if (!this._generatedContentId) {
                this._generatedContentId = "pvd-expand-collapse-content-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedContentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdExpandCollapse.prototype, "generatedSubheadingId", {
        /**
         * Creates a generated id for the subheading
         * @return a generated id to be used for the subheading wrapper
         */
        get: function () {
            if (!this._generatedSubheadingId) {
                this._generatedSubheadingId = "pvd-expand-collapse-subheading-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedSubheadingId;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region LitElement lifecycles
    PvdExpandCollapse.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (changedProperties.has('pvdExpand')) {
            this.expandStateChange();
        }
        if (changedProperties.has('pvdExpandOnPrint')) {
            this.pvdExpandOnPrint
                ? this.addExpandOnPrintEventListener()
                : this.removeExpandOnPrintEventListener();
        }
    };
    PvdExpandCollapse.prototype.firstUpdated = function () {
        _super.prototype.firstUpdated.call(this);
        this._pvdExpand =
            this.hasAttribute('pvd-expand') && this.getAttribute('pvd-expand') !== 'false';
        this._contentEl = this.querySelector('.pvd-expand-collapse__content-wrapper');
        this._state = this.pvdExpand ? ExpandCollapseState.expanded : ExpandCollapseState.collapsed;
    };
    Object.defineProperty(PvdExpandCollapse.prototype, "hasTitleHeadingSet", {
        /**
         * Determine if PvdTitleHeadingLevel value is set and if the value is allowed.
         * Allowed heading levels are 2, 3, 4, 5, or 6 of type Number.
         * @returns boolean true if PvdTitleHeadingLevel value is set and allowed
         */
        get: function () {
            var allowedHeadingLevels = [2, 3, 4, 5, 6];
            return this.pvdTitleHeadingLevel && allowedHeadingLevels.includes(this.pvdTitleHeadingLevel);
        },
        enumerable: false,
        configurable: true
    });
    PvdExpandCollapse.prototype.renderButton = function () {
        return x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <button\n        @click=\"", "\"\n        aria-expanded=\"", "\"\n        aria-controls=\"", "\"\n        aria-describedby=\"", "\"\n        class=\"pvd-expand-collapse__interactive-button\"\n        id=\"", "\"\n        type=\"button\"\n      >\n        ", " ", "\n      </button>\n    "], ["\n      <button\n        @click=\"", "\"\n        aria-expanded=\"", "\"\n        aria-controls=\"", "\"\n        aria-describedby=\"", "\"\n        class=\"pvd-expand-collapse__interactive-button\"\n        id=\"", "\"\n        type=\"button\"\n      >\n        ", " ", "\n      </button>\n    "])), this.toggleExpandState, this.pvdExpand, this.generatedContentId, l(this.hasSubHeading ? this.generatedSubheadingId : undefined), this.generatedInteractionButtonId, this.renderIcon(), this.renderSlottedHeading());
    };
    PvdExpandCollapse.prototype.renderIcon = function () {
        return this.scopeTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      <pvd-scoped-icon\n        pvd-icon-class=\"pvd-expand-collapse__icon\"\n        pvd-name=\"action__caret-right\"\n        pvd-size=\"", "\"\n      >\n      </pvd-scoped-icon>\n    "], ["\n      <pvd-scoped-icon\n        pvd-icon-class=\"pvd-expand-collapse__icon\"\n        pvd-name=\"action__caret-right\"\n        pvd-size=\"", "\"\n      >\n      </pvd-scoped-icon>\n    "])), this.iconSize);
    };
    PvdExpandCollapse.prototype.renderHeading = function () {
        switch (this.pvdTitleHeadingLevel) {
            case 2:
                return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<h2 class=\"pvd-expand-collapse__heading\">", "</h2>"], ["<h2 class=\"pvd-expand-collapse__heading\">", "</h2>"])), this.renderButton());
            case 3:
                return x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<h3 class=\"pvd-expand-collapse__heading\">", "</h3>"], ["<h3 class=\"pvd-expand-collapse__heading\">", "</h3>"])), this.renderButton());
            case 4:
                return x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<h4 class=\"pvd-expand-collapse__heading\">", "</h4>"], ["<h4 class=\"pvd-expand-collapse__heading\">", "</h4>"])), this.renderButton());
            case 5:
                return x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<h5 class=\"pvd-expand-collapse__heading\">", "</h5>"], ["<h5 class=\"pvd-expand-collapse__heading\">", "</h5>"])), this.renderButton());
            case 6:
                return x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<h6 class=\"pvd-expand-collapse__heading\">", "</h6>"], ["<h6 class=\"pvd-expand-collapse__heading\">", "</h6>"])), this.renderButton());
        }
    };
    PvdExpandCollapse.prototype.renderSlottedHeading = function () {
        return x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["<div class=\"pvd-expand-collapse__heading-wrapper\">\n      <s-slot name=\"heading\"></s-slot>\n    </div>"], ["<div class=\"pvd-expand-collapse__heading-wrapper\">\n      <s-slot name=\"heading\"></s-slot>\n    </div>"])));
    };
    PvdExpandCollapse.prototype.renderSubheading = function () {
        return x(templateObject_9 || (templateObject_9 = __makeTemplateObject(["<div\n      id=\"", "\"\n      class=\"pvd-expand-collapse__subheading-wrapper\"\n    >\n      <s-slot name=\"subheading\"></s-slot>\n    </div>"], ["<div\n      id=\"", "\"\n      class=\"pvd-expand-collapse__subheading-wrapper\"\n    >\n      <s-slot name=\"subheading\"></s-slot>\n    </div>"])), this.generatedSubheadingId);
    };
    PvdExpandCollapse.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-expand-collapse-root"),
            modifierPrefix: 'pvd-expand-collapse',
            modifiers: [
                {
                    condition: true,
                    className: "".concat(this.pvdSize),
                },
                {
                    condition: true,
                    className: this._state,
                },
            ],
        };
        return x(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n        ", "\n        <div\n          aria-hidden=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-expand-collapse__content-wrapper\"\n          id=\"", "\"\n          role=\"region\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        ", "\n        ", "\n        <div\n          aria-hidden=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-expand-collapse__content-wrapper\"\n          id=\"", "\"\n          role=\"region\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "])), getClassName(classMap), this.hasTitleHeadingSet ? this.renderHeading() : this.renderButton(), this.hasSubHeading ? this.renderSubheading() : A, !this.pvdExpand, this.generatedInteractionButtonId, this.generatedContentId);
    };
    //#region Component configuration
    PvdExpandCollapse.componentName = 'expand-collapse';
    __decorate([
        t(),
        __metadata("design:type", String)
    ], PvdExpandCollapse.prototype, "_state", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disable-animation' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-animation'))),
        __metadata("design:type", Boolean)
    ], PvdExpandCollapse.prototype, "pvdDisableAnimation", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-expand-on-print' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-expand-on-print'))),
        __metadata("design:type", Boolean)
    ], PvdExpandCollapse.prototype, "pvdExpandOnPrint", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdExpandCollapse.prototype, "pvdSize", void 0);
    __decorate([
        n({
            type: Number,
            reflect: true,
            attribute: 'pvd-title-heading-level',
        })
        // no default because this is an opt-in property; providing a default could break consumers slotting in a heading
        ,
        __metadata("design:type", Number)
    ], PvdExpandCollapse.prototype, "pvdTitleHeadingLevel", void 0);
    return PvdExpandCollapse;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

export { DEFAULT_DISABLE_ANIMATION, DEFAULT_EXPAND, DEFAULT_EXPAND_ON_PRINT, DEFAULT_SIZE, EXPAND_COLLAPSE_ANIMATION_DURATION, ExpandCollapseState, PvdExpandCollapse };
